
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class PurchaseReturnTaxGrid extends Serenity.EntityGrid<PurchaseReturnTaxRow, any> {
        protected getColumnsKey() { return 'Purchase.PurchaseReturnTax'; }
        protected getIdProperty() { return PurchaseReturnTaxRow.idProperty; }
        protected getInsertPermission() { return PurchaseReturnTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return PurchaseReturnTaxRow.localTextPrefix; }
        protected getService() { return PurchaseReturnTaxService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}